import { print } from 'graphql';
import type { MigrationStrategies, RxCollection, RxDocument, RxJsonSchema } from 'rxdb';

import { gql } from '../../graphql/Client';
import { rootStore } from '../../mobx-models/Root';
import { BaseEntity } from '../../models/BaseEntity';
import { SYNC_LIMIT_LOW } from '../../utilities/constants';
import { RxdbCollectionName } from '../rxdbCollectionName';
import defaultDoc from '../Shared/defaultDoc';

export interface InspectionCategory extends BaseEntity {
  readonly description: string;
  readonly displayOrder: number;
  readonly inspectionId: string;
  readonly detail: string | null;
}
export type InspectionCategoryCollection = RxCollection<InspectionCategory> | null;
export type InspectionCategoryDocument = RxDocument<InspectionCategory>;

export const inspectionCategoriesSchema: RxJsonSchema<InspectionCategory> = {
  type: 'object',
  version: 1,
  description: 'describes a InspectionCategory object',
  primaryKey: 'id',
  properties: {
    id: { type: 'string', maxLength: 36 },
    description: { type: 'string' },
    displayOrder: { type: 'number' },
    inspectionId: { ref: RxdbCollectionName.INSPECTIONS, type: 'string' },
    isDeleted: { type: 'boolean' },
    updatedAt: { type: 'number' },
    version: { type: 'number' },
    detail: { type: ['string', 'null'] },
  },
};

export const inspectionCategoriesPullQueryBuilder = (doc: InspectionCategoryDocument) => {
  if (!doc) {
    doc = { ...defaultDoc, updatedAt: 0 };
  }
  const query = print(gql`
    query inspectionCategoryFeed($siteId: ID!, $updatedAt: Float!, $limit: Int!) {
      inspectionCategoryFeed(lastUpdateAt: $updatedAt, limit: $limit, siteId: $siteId) {
        id
        description
        displayOrder
        inspectionId
        isDeleted
        updatedAt
        version
        detail
      }
    }
  `);

  return {
    query,
    variables: {
      siteId: rootStore.user.siteId,
      updatedAt: doc.updatedAt,
      limit: SYNC_LIMIT_LOW,
    },
  };
};

export const inspectionCategoriesMigrationStrategies: MigrationStrategies = {
  1: (oldDoc: InspectionCategoryDocument) => {
    return { ...oldDoc, detail: null };
  },
};

export default {};
